import React from 'react';
import { StyledOtpInput } from './style';
import { StyledError, StyledSpan } from '../../../Theme/CommonStyled';
import OtpInput from 'react-otp-input';

type OtpInputType = {
  dataValue: string;
  onChange: (value: string) => void;
  error?: boolean;
  errorMessage?: string;
};
const LoginOtpInput: React.FC<OtpInputType> = ({
  dataValue,
  onChange,
  error,
  errorMessage
}) => {
  return (
    <>
      <OtpInput
        value={dataValue}
        onChange={onChange}
        shouldAutoFocus
        numInputs={5}
        inputType={'number'}
        renderSeparator={<StyledSpan mr={5}></StyledSpan>}
        renderInput={(props) => (
          <StyledOtpInput error={error} dataValue={dataValue} {...props} />
        )}
      />
      {error && <StyledError>{errorMessage} </StyledError>}
    </>
  );
};

export default LoginOtpInput;
